// extracted by mini-css-extract-plugin
export default {"buttonIcon":"LearnerPassStatus_buttonIcon__cB-Jr"};